module.exports = __webpack_public_path__ + "static/toggl-track-creatives-ee6afeaee5f6d2a6319b8d2330702c85.jpg";